import styled, { css } from 'styled-components';
import { Breakpoints } from '../../styled/constants';

export const HeaderWrapperBlock = styled.div<{
  $isSearchPage: boolean;
  $isCurrentItemPage: boolean;
  $isAdCreateEditPage: boolean;
}>`
  ${({ $isSearchPage, $isCurrentItemPage }) =>
    ($isSearchPage || $isCurrentItemPage) &&
    css`
      ${$isSearchPage &&
      css`
        background-color: ${({ theme }) => theme.colors.background.primary};
        height: 60px;
      `};
    `};

  ${({ $isSearchPage, $isAdCreateEditPage, $isCurrentItemPage, theme }) =>
    ($isSearchPage || $isAdCreateEditPage || $isCurrentItemPage) &&
    css`
      > header {
        display: none;
      }

      @media screen and (min-width: ${$isSearchPage
          ? theme.tabletBreakpoint
          : `${Breakpoints.tablet}px`}) {
        > header {
          display: flex;
        }
        height: max-content;
      }
    `}
`;
